module.exports = __webpack_public_path__ + "static/media/alert.c7a75b4d.svg";